(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('airportsController', airportsController)
        .controller('newAirportController', newAirportController)
        .controller('editAirportController', editAirportController)
        .controller('deleteAirportController', deleteAirportController)

    airportsController.$inject = ['linkService', 'tabs', 'airports'];
    newAirportController.$inject = ['linkService', 'tabs', 'countries', 'regionService', 'cityService', 'airportService'];
    editAirportController.$inject = ['linkService', 'tabs', 'countries', 'regionService', 'cityService',
        'airportService', 'airport', '$stateParams'];
    deleteAirportController.$inject = ['airport', 'airportService', '$uibModalInstance', '$stateParams'];

    function airportsController(linkService, tabs, airports){
        var vm = this;
        vm.pages = [];
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.airports = (airports.data._embedded) ? airports.data._embedded.airports : [];
        vm.pages = airports.data.page;
    }

    function newAirportController(linkService, tabs, countries, regionService, cityService, airportService){
        var vm = this;
        vm.tabs = tabs;
        vm.countries = countries;
        vm.regions = [];
        vm.cities = [];
        vm.isDisabled = false;
        vm.getRegions = function(country){
            if(country != undefined){
                regionService.getRegionsByCountry(linkService.getLinkId(country._links.self.href))
                    .then(function(response){
                        vm.regions = response;
                    });
            }else{
                vm.regions = [];
            }
        }

        vm.getCities = function(region){
            if(region != undefined){
                cityService.getCitiesByRegion(linkService.getLinkId(region._links.self.href), true, true)
                    .then(function(res){
                        vm.cities = res;
                    });
            }else{
                vm.cities = [];
            }
        }

        vm.saveAirport = function(isValid, airport){
            if(isValid){
                var saveAirport = {
                    'cityId': parseInt(linkService.getLinkId(airport.city._links.self.href)),
                    'regionId': parseInt(linkService.getLinkId(airport.region._links.self.href)),
                    'name': airport.name,
                    'iata': airport.iataCode,
                    'icao': (airport.icaoCode) ? airport.icaoCode : "",
                    'boardingGates': [
                        {
                            'number': "string",
                            'predefined': false
                        }
                    ]
                }
                airportService.saveAirport(saveAirport);
            }
        }
    }

    function editAirportController(linkService, tabs, countries, regionService, cityService, airportService,
                                   airport, $stateParams){
        var vm = this;
        vm.tabs = tabs;
        vm.linkService = linkService;
        vm.airportId = $stateParams.id;
        vm.countries = countries;
        vm.regions = [];
        vm.cities = [];
        vm.airport = {
            'country': airport.data._embedded.country,
            'region': airport.data._embedded.region,
            'city': airport.data._embedded.city,
            'name': airport.data.name,
            'iataCode': airport.data.iata,
            'icaoCode': airport.data.icao
        }
        vm.old = angular.copy(vm.airport);
        vm.buttonSave = true;
        vm.isDisabled = true;

        vm.getRegions = function(country){
            if(country != undefined){
                regionService.getRegionsByCountry(linkService.getLinkId(country._links.self.href))
                    .then(function(response){
                        vm.regions = response;
                    });
            }else{
                vm.regions = [];
            }
        }

        vm.getCities = function(region){
            if(region != undefined){
                cityService.getCitiesByRegion(linkService.getLinkId(region._links.self.href), true, true)
                    .then(function(res){
                        vm.cities = res;
                    });
            }else{
                vm.cities = [];
            }
        }

        vm.getRegions(airport.data._embedded.country);
        vm.getCities(airport.data._embedded.region);

        vm.saveAirport = function(isValid, airport){
            if(isValid){
                var saveAirport = {
                    'cityId': parseInt(linkService.getLinkId(airport.city._links.self.href)),
                    'regionId': parseInt(linkService.getLinkId(airport.region._links.self.href)),
                    'iata': airport.iataCode,
                    'icao': (airport.icaoCode) ? airport.icaoCode : "",
                    'name': airport.name,
                    'boardingGates': [
                        {
                            'number': "string",
                            'predefined': false
                        }
                    ]
                }
                airportService.updateAirport(vm.airportId, saveAirport);
            }
        }

        vm.change = function(){
            if(vm.airport.country != undefined && vm.airport.country.name == vm.old.country.name &&
                vm.airport.region != undefined && vm.airport.region.name == vm.old.region.name &&
                vm.airport.city != undefined && vm.airport.city.name == vm.old.city.name &&
                vm.airport.name.toUpperCase() == vm.old.name.toUpperCase() &&
                vm.airport.iataCode.toUpperCase() == vm.old.iataCode.toUpperCase() &&
                vm.airport.icaoCode.toUpperCase() == vm.old.icaoCode.toUpperCase()){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteAirportController(airport, airportService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.airport = airport.data;
        vm.airportId = $stateParams.id;

        vm.deleteAirport = function(){
            airportService.deleteAirport(vm.airportId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
